"use client";
import Link from "next/link";
import { useSearchParams, useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";
import emitter from "@packages/lib/eventEmitter/eventEmitter";
import { usePathname } from "next/navigation";
import { cleanUrl } from "@packages/lib/utlils/url-builder";
const Paginations = ({ totalPages, initialPage, title }: any) => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathName = usePathname();
  // Ensure totalPages and initialPage are valid numbers
  const validTotalPages =
    Number(totalPages) > 0 ? Math.ceil(Number(totalPages)) : 1;
  const validInitialPage = Number(initialPage) > 0 ? Number(initialPage) : 1;
  //console.log
  const [currentPage, setCurrentPage] = useState(validInitialPage);

  // Sync currentPage with URL query parameter 'pageno'
  useEffect(() => {
    const pageFromQuery =
      Number(searchParams.get("pageno")) ||
      Number(searchParams.get("page_no")) ||
      1;
    // Ensure currentPage doesn’t exceed totalPages or go below 1
    setCurrentPage(Math.min(Math.max(1, pageFromQuery), validTotalPages));
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [searchParams, validTotalPages]);

  // Function to build URL with existing query params and updated pageno
  const buildUrl = (page: number | string) => {
    const params = new URLSearchParams(searchParams.toString());
    if (typeof page === "number") {
      const key = process.env.PROJECT === "Whatuni" ? "pageno" : "page_no";
      if (Number(page) === 1) {
        params.delete(key); // Remove param for page 1
      } else {
        params.set(key, page.toString());
      }
    }
    if (title) {
      params.set("title", title);
    }
    return cleanUrl(`${pathName}?${decodeURIComponent(params.toString())}`);
  };

  const pageNumbers: (number | string)[] = [];
  const totalVisiblePages = 7;

  if (validTotalPages <= totalVisiblePages) {
    for (let i = 1; i <= validTotalPages; i++) {
      pageNumbers.push(i);
    }
  } else {
    pageNumbers.push(1); // Always show first page
    if (currentPage <= 3) {
      for (let i = 2; i <= 5; i++) {
        pageNumbers.push(i);
      }
      pageNumbers.push("...");
    } else if (currentPage >= validTotalPages - 2) {
      pageNumbers.push("...");
      for (let i = validTotalPages - 4; i < validTotalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push("...");
      pageNumbers.push(currentPage - 1);
      pageNumbers.push(currentPage);
      pageNumbers.push(currentPage + 1);
      pageNumbers.push("...");
    }
    pageNumbers.push(validTotalPages); // Always show last page
  }

  const items = pageNumbers;

  // Calculate nextPage safely
  const nextPage = Math.min(currentPage + 1, validTotalPages);

  const handlePagination: any = (url: string) => {
    //SR
    // const resultSkeleton = window?.document?.getElementById(
    //   "resultSectionSkeleton"
    // );
    // resultSkeleton?.classList?.remove("hidden");
    emitter.emit("searchresultloading", true);
    const srpageBodySection =
      window?.document?.getElementById("srpageBodySection");
    //PR
    // const PrPageBodySectionSkeleton = window?.document?.getElementById(
    //   "PrPageBodySectionSkeleton"
    // );
    emitter.emit("providerresultloading", true);
    const prPageBodySection =
      window?.document?.getElementById("prPageBodySection");
    window?.history?.pushState(null, "", url);

    srpageBodySection?.classList?.add("hidden");
    prPageBodySection?.classList?.add("hidden");
    // PrPageBodySectionSkeleton?.classList?.remove("hidden");
    window.scrollTo({ top: 0, behavior: "smooth" });
    router.push(url);
  };

  return (
    <>
      {validTotalPages > 1 && (
        <div className="py-[24px] md:py-[40px]">
          <nav aria-label="navigation">
            <ul className="pagination flex justify-center items-center gap-[8px]">
              {currentPage > 1 && (
                <li>
                  <Link
                    className="hidden"
                    href={
                      currentPage > 1
                        ? buildUrl(currentPage - 1)
                        : "javascript:void(0)"
                    }
                  ></Link>
                  <div
                    onClick={() => {
                      handlePagination(buildUrl(currentPage - 1));
                    }}
                    className="hover:bg-blue-100 cursor-pointer flex items-center justify-center text-center px-[2px] py-[8px] rounded-[4px] w-[36px] h-[36px]"
                  >
                    <svg
                      width="7"
                      height="12"
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6 11L1 6L6 1"
                        stroke="#333F48"
                        strokeWidth="1.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </li>
              )}
              {items.map((item, index) => (
                <li key={index}>
                  <Link
                    href={
                      item !== "..." ? buildUrl(item) : "javascript:void(0)"
                    }
                    className="hidden"
                    // className={
                    //   currentPage === item
                    //     ? "block small w-[36px] h-[36px] font-normal text-center px-[2px] py-[8px] rounded-[4px] bg-primary-400 text-white"
                    //     : `block small w-[36px] h-[36px] font-normal text-grey300 text-center px-[2px] py-[8px] rounded-[4px] ${
                    //         item !== "..."
                    //           ? "hover:bg-blue-100 hover:text-primary-400"
                    //           : ""
                    //       }`
                    // }
                  >
                    {/* {item} */}
                  </Link>
                  <div
                    onClick={() => {
                      if (item !== "...") {
                        handlePagination(buildUrl(item));
                      }
                    }}
                    className={
                      currentPage === item
                        ? "block small w-[36px] h-[36px] font-normal text-center px-[2px] py-[8px] rounded-[4px] bg-primary-400 text-white"
                        : ` block small w-[36px] h-[36px] font-normal text-grey300 text-center px-[2px] py-[8px] rounded-[4px] ${
                            item !== "..."
                              ? "cursor-pointer hover:bg-blue-100 hover:text-primary-400"
                              : ""
                          }`
                    }
                  >
                    {item}
                  </div>
                </li>
              ))}
              {currentPage < validTotalPages && (
                <li>
                  <Link
                    className="hidden"
                    href={
                      currentPage < validTotalPages
                        ? buildUrl(nextPage)
                        : " javascript:void(0)"
                    }
                  ></Link>
                  <div
                    onClick={() => {
                      handlePagination(buildUrl(nextPage));
                    }}
                    className="hover:bg-blue-100 cursor-pointer flex items-center justify-center text-center px-[2px] py-[8px] rounded-[4px] w-[36px] h-[36px]"
                  >
                    <svg
                      width="7"
                      height="12"
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1L6 6L1 11"
                        stroke="#333F48"
                        strokeWidth="1.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </li>
              )}
            </ul>
          </nav>
        </div>
      )}
    </>
  );
};

export default Paginations;
